import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  static values = {
    url: String,
    jsErb: Boolean,
    refreshSelectpicker: String,
    renableOnLoadElement: String,
  };

  connect() {
    this.loadRemoteContent();
  }

  loadRemoteContent() {
    var controller = this;

    if(controller.jsErbValue){
     $.ajax({
        url: this.urlValue,
        type: "GET",
        dataType: "script",
      });
    } else {
      fetch(this.urlValue)
        .then((response) => response.text())
        .then(function (html) {
          controller.element.innerHTML = html;

          if (controller.renableOnLoadElementValue !== undefined) {
            $(controller.renableOnLoadElementValue).prop("disabled", false);
            $(controller.renableOnLoadElementValue)
              .find(".loader")
              .addClass("d-none");
          }

          $('[data-toggle="tooltip"]').tooltip({ sanitize: false });

          onmount();

          if(window.setupJSRemoteForm !== undefined ) {
            window.setupJSRemoteForm();
          }

          if (controller.refreshSelectpickerValue !== "disabled") {
            $(".selectpicker").selectpicker("refresh");
          }

          if ($(".js-copy-to-keyboard").is("*")) {
            controller.copyToKeyboardJs();
          }

          if ($(".js-toggler-show-target").is("*") || $(".js-toggler-hide-target").is("*")) {
            controller.initTogglers();
          }

          window.loadFlatpickr();
        });
    }
  }

  initTogglers() {
    $("body").on('change', ".js-toggler-show-target", function(){
      $($(this).data('showTarget')).show();
    });

    $("body").on('change', ".js-toggler-hide-target", function(){
      $($(this).data('hideTarget')).hide();
    });
  }

  copyToKeyboardJs() {
    $('.js-btn-copy-to-clipboard').unbind('click');
    $(".js-btn-copy-to-clipboard").click(function () {
      var clipboardContents = $(this)
        .closest(".js-copy-to-clipboard-container")
        .find(".js-copy-to-keyboard");
      clipboardContents.click();
      return false;
    });

    $('.js-copy-to-keyboard').unbind('click');
    $(".js-copy-to-keyboard").click(function () {
      window.copyTextToBrowserClipboard($(this).val());

      var confirmationDiv = $(this)
        .closest(".js-copy-to-clipboard-container")
        .find(".js-copied-to-keyboard-confirmation");
      confirmationDiv.fadeIn();

      setTimeout(function () {
        confirmationDiv.fadeOut();
        return;
      }, 2750);

      return false;
    });
  }
}
